module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/PrinceOfPersia_xbox_lrg.c54ab02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/PrinceOfPersia_xbox_lrg.jpg
// module id = cbXS
// module chunks = 0